import { createTheme, MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ReactNode } from "react";

interface NotificationWrapperProps {
  children: ReactNode;
}

const theme = createTheme({
  fontFamily: "Poppins, sans-serif",
  primaryColor: "green",
  colors: {
    green: [
      "#eafdf1",
      "#d8f7e3",
      "#b0edc6",
      "#84e3a6",
      "#61da8b",
      "#4ad57a",
      "#3dd371",
      "#2eba5f",
      "#24a653",
      "#108f44",
    ],
  },
});

export default function NotificationWrapper({
  children,
}: NotificationWrapperProps) {
  return (
    <MantineProvider theme={theme}>
      {children}
      <Notifications limit={4} />
    </MantineProvider>
  );
}
